import jiashao from "./index.vue";
import jiashaoHome from "./Home.vue";
import station from "./station.vue";
import stationCad from "./CAD_station.vue";
import stationV3 from "./stationV3.vue";
import gasClamp_towerStation from "./gasClamp_towerStation.vue";
import gasClamp_steelboxStation from "./gasClamp_steelboxStation.vue";
import gasClamp_towerPower from "./gasClamp_towerPower.vue";
import gasClamp_steelboxPower from "./gasClamp_steelboxPower.vue";
import dataSourceConnection from "./dataSourceConnection.vue";

const emptyComponent = () => import("./emptyRouterComponent.vue");
const errorRecord = () => import("./../../components/ErrorRecordControl.vue");
const simpleCurrentData = () => import("./../../components/SimpleCurrentData.vue");
const dataHistory = () => import("./../../components/DataHistory.vue");
const SimpleHumidityList = () => import("../../components/SimpleHumidityList.vue");
const login = () => import("./login.vue");

export default [
  {
    path: "/jiashaoIndex",
    name: "jiashaoIndex",
    component: jiashaoHome,
  },
  {
    path: "/jiashao/login",
    name: "jiashaoLogin",
    component: login,
  },
  {
    path: "/jiashao",
    name: "jiashao",
    redirect: "/jiashao",
    component: jiashao,
    children: [
      {
        path: "dataSourceConnection",
        name: "dataSourceConnection",
        component: dataSourceConnection,
      },
      {
        path: "currentDataTable",
        name: "currentDataTable",
        component: simpleCurrentData,
      },
      {
        path: "currentHumidityList",
        name: "currentHumidityList",
        component: SimpleHumidityList,
      },
      {
        path: "dataHistory",
        name: "dataHistory",
        component: dataHistory,
      },
      {
        path: "errorRecord",
        name: "errorRecord",
        component: errorRecord,
      },
      // {
      //   path: "towerStation",
      //   name: "towerStation",
      //   redirect: "/jiashao/towerStation/station6",
      //   component: emptyComponent,
      //   children: [
      //     {
      //       path: "station6",
      //       name: "station6",
      //       component: station
      //     },
      //     {
      //       path: "station12",
      //       name: "station12",
      //       component: station
      //     },
      //   ]
      // },
      {
        path: "gasclamp",
        name: "gasclamp",
        redirect: "/jiashao/gasclamp/towerStation",
        component: emptyComponent,
        children: [
          {
            path: "towerStation",
            name: "towerStation",
            component: gasClamp_towerStation,
          },
          {
            path: "steelboxStation",
            name: "steelboxStation",
            component: gasClamp_steelboxStation,
          },
        ],
      },
      {
        path: "power",
        name: "power",
        redirect: "/jiashao/power/towerStation",
        component: emptyComponent,
        children: [
          {
            path: "towerStation",
            name: "towerStation",
            component: gasClamp_towerPower,
          },
          {
            path: "steelboxStation",
            name: "steelboxStation",
            component: gasClamp_steelboxPower,
          },
        ],
      },
      {
        path: "towerStation",
        name: "towerStation",
        redirect: "/jiashao/towerStation/station2",
        component: emptyComponent,
        children: [
          {
            path: "station1",
            name: "station1",
            component: stationV3,
          },
          {
            path: "station2",
            name: "station2",
            component: stationV3,
          },
          {
            path: "station3",
            name: "station3",
            component: stationV3,
          },
          {
            path: "station4",
            name: "station4",
            component: stationV3,
          },
          {
            path: "station5",
            name: "station5",
            component: stationV3,
          },
          {
            path: "station6",
            name: "station6",
            component: stationV3,
          },
          {
            path: "station7",
            name: "station7",
            component: stationV3,
          },
          {
            path: "station8",
            name: "station8",
            component: stationV3,
          },
          {
            path: "station10",
            name: "station10",
            component: stationV3,
          },
          {
            path: "station12",
            name: "station12",
            component: stationV3,
          },
          {
            path: "station16",
            name: "station16",
            component: stationV3,
          },
          {
            path: "station29",
            name: "station29",
            component: stationV3,
          },
        ],
      },
      // {
      //   path: "towerStationCAD",
      //   name: "towerStationCAD",
      //   redirect: "/jiashao/towerStationCAD/station6",
      //   component: emptyComponent,
      //   children: [
      //     {
      //       path: "station6",
      //       name: "station6",
      //       component: stationCad
      //     },
      //     {
      //       path: "station12",
      //       name: "station12",
      //       component: stationCad
      //     },
      //   ]
      // },
      {
        path: "steelboxStation",
        name: "steelboxStation",
        redirect: "/jiashao/steelboxStation/station19",
        component: emptyComponent,
        children: [
          {
            path: "station9",
            name: "station9",
            component: stationV3,
          },
          {
            path: "station11",
            name: "station11",
            component: stationV3,
          },
          {
            path: "station13",
            name: "station13",
            component: stationV3,
          },
          {
            path: "station14",
            name: "station14",
            component: stationV3,
          },
          {
            path: "station15",
            name: "station15",
            component: stationV3,
          },
          {
            path: "station17",
            name: "station17",
            component: stationV3,
          },
          {
            path: "station18",
            name: "station18",
            component: stationV3,
          },
          {
            path: "station19",
            name: "station19",
            component: stationV3,
          },
          {
            path: "station20",
            name: "station20",
            component: stationV3,
          },
          {
            path: "station21",
            name: "station21",
            component: stationV3,
          },
          {
            path: "station25",
            name: "station25",
            component: stationV3,
          },
          {
            path: "station26",
            name: "station26",
            component: stationV3,
          },
          {
            path: "station28",
            name: "station28",
            component: stationV3,
          },
          {
            path: "station30",
            name: "station30",
            component: stationV3,
          },
          {
            path: "station31",
            name: "station31",
            component: stationV3,
          },
          {
            path: "station32",
            name: "station32",
            component: stationV3,
          },
        ],
      },
      {
        path: "rigidHingeStation",
        name: "rigidHingeStation",
        redirect: "/jiashao/rigidHingeStation/station23",
        component: emptyComponent,
        children: [
          {
            path: "station22",
            name: "station22",
            component: stationV3,
          },
          {
            path: "station23",
            name: "station23",
            component: stationV3,
          },
          {
            path: "station24",
            name: "station24",
            component: stationV3,
          },
          {
            path: "station27",
            name: "station27",
            component: stationV3,
          },
        ],
      },
    ],
  },
];
